import { AUTH_DOMAIN_NAME } from './env';
import Http from './config/http';

export default {
  validUsername({
    formData
  } = {}) {
    return Http({
      method: 'post',
      url: `${AUTH_DOMAIN_NAME}?app_id=${window.app_id}&act=isuniqueusername`,
      data: formData,
    });
  },

  loginByEmail({
    formData
  } = {}) {
    return Http({
      method: 'post',
      url: `${AUTH_DOMAIN_NAME}?app_id=${window.app_id}&act=doLogin`,
      data: formData,
    });
  },

  registerByEmail({
    formData
  } = {}) {
    return Http({
      method: 'post',
      url: `${AUTH_DOMAIN_NAME}?app_id=${window.app_id}&act=sendverifyemail`,
      data: formData,
    });
  },

  registerInfo({
    formData
  } = {}) {
    return Http({
      method: 'post',
      url: `${AUTH_DOMAIN_NAME}?app_id=${window.app_id}&act=doregister`,
      data: formData,
    });
  },

  inputNewEmail({
    formData
  } = {}) {
    return Http({
      method: 'post',
      url: `${AUTH_DOMAIN_NAME}?app_id=${window.app_id}&act=sendverifyemail`,
      data: formData
    });
  },

  forgetPassword({
    formData
  } = {}) {
    return Http({
      method: 'post',
      url: `${AUTH_DOMAIN_NAME}?app_id=${window.app_id}&act=sendresetpasswordemail`,
      data: formData
    });
  },

  resetPassword({
    formData
  } = {}) {
    return Http({
      method: 'post',
      url: `${AUTH_DOMAIN_NAME}?app_id=${window.app_id}&act=doresetpassword`,
      data: formData
    });
  },
};
